<!--
/**
* @name: Add.vue
* @description: 角色添加
* @author: 于海威
* @create: 2020/08/07 17:58:51
* @update: 2020/08/07 17:58:51
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-form titleAlign="left" titleWidth="100px" contentWidth="600px">
      <template v-if="!isView">
        <y-form-item title="角色ID:" required>
          <k-input placeholder="创建后自动生成" v-model="editPara.id" block disabled></k-input>
        </y-form-item>
        <y-form-item title="角色名称:" required>
          <k-input placeholder="请输入角色名称" v-validate="'required'" v-model="editPara.name" block maxlength="20"></k-input>
        </y-form-item>
        <y-form-item title="角色类型:" required>
          <div>
            <k-radio value="HEAD" v-model="editPara.type">总部</k-radio>
            <k-radio value="SUB" v-model="editPara.type">子公司</k-radio>
          </div>
        </y-form-item>
        <y-form-item title="角色描述:" align="top">
          <k-input tag="textarea" placeholder="请描述该角色职责" v-model="editPara.description" block></k-input>
        </y-form-item>
        <y-form-item title="角色权限:" required align="top">
          <div class="text-gray-4">请勾选该角色可操作权限</div>
          <k-tree
            :data.sync="treeDataList"
            searchField="name"
            :selectedData.sync="selectedData"
            :selectedKeys.sync="selectedKeys"
            class="mt-1"
            selectedRule="some"
            childField="children"
            keyField="id"
            textField="name"
            hasCheckbox
          ></k-tree>
        </y-form-item>
      </template>
      <template v-else>
        <y-form-item title="角色ID:" required>
          {{ editPara.id }}
        </y-form-item>
        <y-form-item title="角色名称:" required>
          {{ editPara.name }}
        </y-form-item>
        <y-form-item title="角色类型:" required>
          {{ editPara.type == "HEAD" ? "总部" : "子公司" }}
        </y-form-item>
        <y-form-item title="角色描述:">
          {{ editPara.description }}
        </y-form-item>
        <y-form-item title="角色权限:" align="top" required>
          {{ editPara.permissionIdList }}
        </y-form-item>
      </template>
    </y-form>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onCancel(true, false)">取消</k-button>
      <k-button type="primary" :disabled="saveButtonStatus || isDisabled" @click="onSave">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DETAIL,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_SAVE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_UPDATE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_LIST_MENU_TREE,
} from "@/assets/modules/apiList";

const initPara = () => ({
  description: "",
  name: "",
  permissionIdList: [],
  type: "HEAD",
});
export default {
  data() {
    return {
      isLoading: false,
      treeDataList: [],
      selectedData: [],
      editPara: initPara(),
      isDisabled: false,
      isSaving: false,
      selectedKeys: [],
      isView: false,
      isEdit: false,
    };
  },
  watch: {
    selectedKeys(v) {
      this.editPara.permissionIdList = JSON.parse(JSON.stringify(v)).map((m) => parseInt(m));
      if (this.editPara.permissionIdList.length === 0) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      const para = JSON.parse(JSON.stringify(this.editPara));
      if (para.name.replace(/\s*/, "").length < 1) {
        status = true;
      }
      if (para.permissionIdList.length < 1) {
        status = true;
      }
      return status;
    },
  },
  methods: {
    getRole(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_DETAIL,
        para: { id: parseInt(id) },
      })
        .then((res) => {
          this.isLoading = false;
          let tmp = [];
          let tmpName = [];
          if (res.systemPermissionVOList && res.systemPermissionVOList.length) {
            res.systemPermissionVOList.forEach((s) => {
              tmp.push(s.id);
              tmpName.push(s.name);
            });
          }
          if (this.isView) {
            res.permissionIdList = tmpName.join(", ");
          } else {
            this.selectedKeys = tmp;
          }
          this.editPara = res;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getJurisdictionList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_LIST_MENU_TREE,
        para: {},
      }).then((res) => {
        this.treeDataList = res;
      });
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "roleList",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onSave() {
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      let api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_SAVE;
      if (this.isEdit) {
        api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_ROLE_UPDATE;
      }
      this.isSaving = true;
      this.isLoading = true;
      this.$fetch({
        api,
        para,
        isSuccessTip: true,
      })
        .then(() => {
          this.isLoading = false;
          this.isSaving = false;
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
  },
  filters: {
    id2name(idList) {
      console.log(this.treeDataList);
      let jurisdictionList = this.treeDataList;
      let tmp = [];
      idList = idList.map((m) => m.toString());
      jurisdictionList.forEach((j) => {
        if (idList.indexOf(j.id.toString())) {
          tmp.push(j.name);
        }
      });
      return tmp.join(", ");
    },
  },
  created() {
    this.getJurisdictionList();
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getRole(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initPara();
    this.selectedData = [];
    this.selectedKeys = [];
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getRole(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
